export class GscService {
  async postForm<T extends Object>(
    endpoint: string,
    payload: T
  ): Promise<Response> {
    const form = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      form.set(key, value.toString());
    });

    return await fetch(endpoint, {
      method: "post",
      body: form,
    });
  }
}
